module.exports = __webpack_public_path__ + "static/media/HomeBackgroundLearnToSail.5a2bef88.jpg";